import { NgModule } from '@angular/core';

import { AutoLinkComponent } from './AutoLink.Component';
import { CommonModule } from '@angular/common';

@NgModule({
	declarations:[AutoLinkComponent],
	exports: [AutoLinkComponent],
	imports: [CommonModule]
})
export class AutoLinkModule {}
